import React from 'react'
import { Pagination } from 'element-react'

const PaginationSG = () => {
    return (
        <div>
            <Pagination layout="prev, pager, next" total={50} small={true} />
        </div>
    )
}

export default PaginationSG
